import {ChangeDetectionStrategy, Component, input, model} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {Checkbox} from 'primeng/checkbox';

@Component({
  selector: 'app-coverage-option-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslocoPipe, Checkbox],
  templateUrl: './coverage-option-toggle.component.html',
})
export class CoverageOptionToggleComponent {
  readonly inputId = input.required<string>();
  readonly labelKey = input.required<string>();

  readonly checked = model(false);
}
